<template>
  <div class="modal-backdrop">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('upload') }} {{ $t('photo') }}</h5>
          <button type="button" class="close" @click="close" aria-label="Close">
            <span aria-hidden="true"><img src="@/assets/icon/close.svg"></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="drag-n-drop" v-cloak @drop.prevent="addFile" @dragover.prevent @click="$refs.image.click()">
            <div class="text" v-if="!previewName">
              {{ $t('drag-and-drop-file') }}
            </div>
            <div class="text" v-else>
              {{ previewName }}
            </div>
            <input ref="image" class="d-none" type="file" accept="image" @change="uploadImage">
          </div>
          <div class="buttons">
            <div class="btn-cancel">
              <a class="btn" @click="uploadNewImage">{{ $t('upload') }} {{ $t('new') }} {{ $t('photo') }}</a>
            </div>
            <div class="btn-apply">
              <a class="btn" @click="endUpload">{{ $t('continue') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'upload-image-modal',
  props: ['name'],
  data: function(){
    return{
      image: '',
      previewName: ''
    }
  },
  methods: {
    addFile(e) {
      let droppedFiles = e.dataTransfer.files[0];
      if(!droppedFiles) return;
      this.image = droppedFiles;
      this.previewName = droppedFiles.name;
    },
    uploadImage: function(){
      this.image = this.$refs.image.files[0];
      this.previewName = this.image.name;
    },
    uploadNewImage: function(){
      this.image = '';
      this.previewName = '';
    },
    endUpload: function(){
      if(this.image){
        this.$root.$emit('image', this.image);
      }
      this.close();
    },
    close: function() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>

.buttons{
  margin-top: 37px;
  display: flex;
  justify-content: space-between;
}

.modal-content{
  border: none;
  border-radius: 10px;
  padding: 40px 40px;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  position: relative;
  border-bottom: none;
  padding: 0;
  color: #484848;
  justify-content: space-between;
}

.modal-body{
  margin-top: 30px;
  padding: 0 !important;
}

.drag-n-drop{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  background: rgba(233, 159, 84, 0.1);
  border: 1px dashed #E99F54;
  border-radius: 10px;
  height: 265px;
  max-width: 482px;
  cursor: pointer;
}

.drag-n-drop .text{
  font-size: 14px;
  line-height: 145%;
  color: #606F89;
}

.allow-type{
  margin-top: 15px;
}

.allow-type p{
  font-size: 14px;
  line-height: 145%;
  color: #606F89;
  margin-top: 5px;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
}
</style>